<!-- eslint-disable vue/no-v-html -->
<template>
    <ui-modal
        icon="far fa-cog"
        name="simulator-rules"
        title="Regras do Simulador"
        size="lg"
    >
        <div>
            <div class="popover__wrapper">
                <a target="_blank" href="https://cdn.appfacilita.com/static/documentations/simulation/regrasdosimulador.pdf">
                    <div class="fa fa-question-circle popover__title" aria-hidden="true"/>
                </a>
                <div class="popover__content">
                    Aprenda como utilizar este recurso
                </div>
            </div>
        </div>
        <div class="simulator-rules scroll-color">

            <!-- @start .define-rules -->
            <div class="define-rules">
                <div class="modal-title">Definir Regras</div>
                <form class="define-rules-form">
                    <div class="form-row">
                        <div class="col">
                            <ui-select
                                v-model="form.delimiter"
                                label="Selecione a parcela mensal limite"
                                size="md">
                                <option
                                    v-for="delimiter in salesTableDelimiters"
                                    :key="delimiter.id"
                                    :value="delimiter.id"
                                    :selected="delimiter.id === parseInt(form.delimiter)">
                                    {{ delimiter.name }}
                                </option>
                            </ui-select>
                        </div>
                        <!--*************************************************************************
                        *** Campo Comentado a pedido do Evertom para Tiago Dariel dia 14/06/2021 ****
                        **************************************************************************-->
                        <!--*************************************************************************
                        *** Campo Descomentado a pedido do Evertom para Tiago Dariel dia 15/06/2021 *
                        **************************************************************************-->
                        <div class="col">
                            <ui-select-tags
                                v-model="form.salesTable.duedates"
                                :options="duedateOptions"
                                size="md"
                                label="Selecione os dias para vencimento das parcelas"
                                remove-selected-item
                            />
                        </div>

                        <div class="col behavior-configs">
                            <ui-switch
                                v-model="form.salesTable.data.entryShowAllDays"
                                :checked="form.salesTable.data.entryShowAllDays"
                                label="Ignorar os dias definidos para as parcelas do tipo Entrada"
                                design="md primary"
                            />

                            <ui-switch
                                v-model="form.salesTable.data.allowExtend"
                                :checked="form.salesTable.data.allowExtend"
                                label="Permitir a prorrogação e antecipação de parcelas"
                                design="md primary"
                            />
                        </div>
                    </div>

                    <div class="buttons">
                        <ui-button
                            :loading="loadingSaveRule"
                            design="md primary mw-100"
                            @click="submitSalesTable">
                            Salvar
                        </ui-button>
                    </div>
                </form>
            </div>
            <!-- @end .define-rules -->


            <div class="register-rules">
                <div class="modal-title">Cadastrar Regras</div>

                <!-- @start .register-rules-form -->
                <form class="register-rules-form">
                    <div class="form-row form-container-rules">
                        <div class="col">
                            <ui-select
                                :useTouchedValidation="true"
                                v-model="form.data.type"
                                :label="form.fields.type.label"
                                :required="form.fields.type.required"
                                :clearable="false"
                                line-height
                                @input="ruleTypeChangeHandler">
                                <option
                                    v-for="(rule, index) in ruleTypeOptionsComputed"
                                    :key="index"
                                    :value="rule.value"
                                    :selected="form.data.type === rule.value">
                                    {{ rule.label }}
                                </option>
                            </ui-select>
                        </div>

                        <div class="col">
                            <ui-input
                                v-model="form.data.days"
                                :label="form.fields.days.label"
                                :disabled="form.fields.days.disabled"
                                :required="form.fields.days.required"
                                type="tel"/>
                        </div>

                        <div class="col">
                            <ui-input
                                v-model="form.data.amount"
                                :label="form.fields.amount.label"
                                :disabled="form.fields.amount.disabled"
                                :required="form.fields.amount.required"
                                percent
                                type="tel"
                                group="%"
                            />
                        </div>

                        <div class="col">
                            <ui-select
                                :useTouchedValidation="true"
                                v-model="form.data.tolerance_status"
                                :label="form.fields.tolerance_status.label"
                                :clearable="false"
                                :required="form.fields.tolerance_status.required"
                                line-height
                                @input="toleranceStatusChangeHandler">
                                <option
                                    v-for="(status, index) in toleranceStatusOptionsComputed"
                                    :key="index"
                                    :value="status.value"
                                    :selected="form.data.tolerance_status === status.value">
                                    {{ status.label }}
                                </option>
                            </ui-select>
                        </div>

                        <div class="col">
                            <ui-input
                                v-model="form.data.tolerance"
                                :label="form.fields.tolerance.label"
                                :disabled="form.fields.tolerance.disabled"
                                percent
                                type="tel"
                                group="%"
                            />
                        </div>
                    </div>

                    <div v-if="form.editing" class="buttons">
                        <ui-button design="danger md" @click="clearForm">Cancelar edição</ui-button>
                        <ui-button design="success md" @click="submit">Salvar alterações</ui-button>
                    </div>

                    <div v-else class="buttons">
                        <div v-show="form.message" class="message" v-html="form.message" />
                        <ui-button design="primary md mw-150" :loading="loadingAddRule" @click="submit">
                            Adicionar regra
                        </ui-button>
                    </div>
                </form>
                <!-- @end .register-rules-form -->


                <!-- @start .register-rules-table -->
                <div v-if="!load && rules.length" class="register-rules-table">
                    <ui-overlay-load v-if="loadingTableUpdate" />

                    <div class="ui-table">
                        <table summary="Regra, Dias, Valor Recibo, Tolerância Máxima">
                            <thead>
                                <tr>
                                    <th>Regra</th>
                                    <th>Em quantos dias?</th>
                                    <th>Valor a ser recebido <small>(%)</small></th>
                                    <th>Tolerância Máxima</th>
                                    <th width="40">&nbsp;</th>
                                </tr>
                            </thead>

                            <tbody>
                                <ui-table-line
                                    v-for="(rule, index) in rules"
                                    :key="rule.id"
                                    :data="rule"
                                    :index="index"
                                    :selected="form.editingIndex"
                                    @edit="editHandler"
                                    @remove="removeHandler"/>
                            </tbody>
                        </table>
                    </div>
                </div>
                <!-- @end .register-rules-table -->

                <ui-no-content-box
                    v-if="rules.length == 0"
                    :load="load"
                    :reload-btn="false"
                    icon="far fa-file"
                    text="Não encontramos nenhuma regra"
                    :max-height="200"
                />
            </div>

        </div>
    </ui-modal>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
    import { uiInput, uiSelect, uiSelectTags, uiSwitch } from '@/components/ui/form'
    import { uiModal } from '@/components/ui/modal'
    import { salesTable, simulatorRule } from '@/services/axios'
    import { mapGetters } from 'vuex'
    import { uiNoContentBox, uiOverlayLoad } from '@/components/ui'
    import uiTableLine from '@/components/ui-facilita/products/step-four/simulator-rules/table-line'
    

    const defaultFormData = (data) => {
        return {
            rule: '',
            type: null,
            days: '',
            amount: '',
            tolerance: '',
            tolerance_status: null,
            sales_table_id: data.id
        }
    }

    const defaultForm = () => {
        return {
            editing: false,
            editingIndex: null,
            message: '',
            fields: {
                type: {
                    label: 'Regra',
                    disabled: false,
                    required: true
                },
                days: {
                    label: 'Em até quantos dias?',
                    disabled: false,
                    required: true
                },
                amount: {
                    label: 'Total a ser recebido',
                    disabled: false,
                    required: true
                },
                tolerance: {
                    label: 'Tolerância Máx. (Opcional)',
                    disabled: false,
                    required: false
                },
                tolerance_status: {
                    label: 'Especificar tolerância?',
                    disabled: false,
                    required: true
                }
            },
            salesTable: {
                id: null,
                duedates: [],
                sales_table_flow: [],
                data: {
                    entryShowAllDays: false,
                    allowExtend: true
                }
            },
            delimiter: null,
            data: {}
        }
    }

	export default {
        name: "simulator-rules",
        components: {
            uiButton,
            uiModal,
            uiInput,
            uiSelect,
            uiSelectTags,
            uiTableLine,
            uiNoContentBox,
            uiOverlayLoad,
            uiSwitch
        },

		data: function() {
			return {
                load: true,
                loadingSaveRule: false,
                loadingTableUpdate: false,
                loadingEditing: false,
                loadingAddRule: false,
                unsubscribe: null,
                form: { ...defaultForm() },
                ruleTypeOptions: [
                    { value: 'captation', label: 'Captação' },
                    { value: 'entry', label: 'Entrada' },
                    { value: 'present_value', label: 'Valor Presente' },
                    { value: 'bank_financing', label: 'Financiamento' },
                    { value: 'balloon', label: 'Balão' }
                ],
                duedateOptions: [],
                rules: []
            }
        },
        computed: {
            ...mapGetters('salesTable', {
                salesTableConfig: 'getSalesTableConfig',
                salesTableDelimiters: 'getSalesTableDelimiters'
            }),
            /**
             * Computed property para controlar as opções de regras a serem cadastradas
             */
            ruleTypeOptionsComputed() {
                let options = [...this.ruleTypeOptions]

                if (this.rules && this.rules.length) {
                    let rules = this.rules.map(rule => rule.type)
                    options = options.filter(option => {
                        if (this.form.editing && this.form.data.type ===  option.value) return true

                        return !rules.includes(option.value)
                    })
                }

                return options
            },
            /**
             * Computed property para gerar as opções de status da tolerância de acordo
             * com o tipo de regra selecionado
             */
            toleranceStatusOptionsComputed() {
                let options = []

                switch (this.form.data.type) {
                    case 'captation':
                    case 'present_value':
                    case 'entry':
                        options = [
                            { value: 0, label: 'Desativado' },
                            { value: 1, label: 'Sim, obrigar valor mínimo' },
                            { value: 2, label: 'Sim, definir tolerância' }
                        ]
                        break

                    default:
                        options = [
                            { value: 0, label: 'Desativado' },
                            { value: 1, label: 'Sim, obrigar valor máximo' },
                            { value: 2, label: 'Sim, definir tolerância' }
                        ]
                        break;
                }

                return options
            }
        },

        created() {
            this.$root.$on("modal-close-simulator-rules", () => {
                setTimeout(() => {
                    this.rules = []
                    this.message = ''
                    this.load = true
                }, 400);
            })

            /** Subscreve para uma mutation */
            this.unsubscribe = this.$store.subscribe((mutation) => {
                /** Atualiza o conteúdo da tabela */
                if (mutation.type === "salesTable/SET_SALES_TABLE_CONFIG") {
                    this.$set(this.form, 'data', { ...defaultFormData(this.salesTableConfig) })
                    /**
                     * Verifica se a tabela de vendas foi cadastrada sem a propriedade data,
                     * e cadastra o valor padrão para esta propriedade
                     */
                    if (!this.salesTableConfig.data) this.salesTableConfig.data = { entryShowAllDays: false }
                    this.$set(this.form, 'salesTable', { ...this.salesTableConfig })
                    this.setDelimiter()
                    this.getModalConfig()
                }
            })

            /** Limpa o formulário */
            this.$root.$on('modal-close-simulator-rules', () => {
                this.form = { ...defaultForm() }
                this.duedateOptions = []
            })

            /**
             * Seta a propriedade duedateOptions que será utilizada no select-tags para que
             * o component atualize os valores selecionados
             */
            this.$root.$on('modal-open-simulator-rules', () => {
                this.duedateOptions = [...Array(30).keys()].map(i => i + 1)
            })
        },
        beforeDestroy() {
            /** Desubscreve da mutation */
            this.unsubscribe()
        },
		methods: {
            /**
             * Carrega as regras do simulador de acordo com a tabela de vendas selecionada
             */
            getModalConfig() {
                salesTable.getSimulatorRules(this.salesTableConfig.id)
                    .then(response => {
                        this.rules = [...response.data]
                        this.load = false
                    })
                    .catch(error => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                        console.log('error', error)
                    })
            },
            /**
             * Seta a propriedade delimiter do formulário da tabela de vendas, para selecionar o
             * fluxo delimitador
             */
            setDelimiter() {
                const delimiter = this.salesTableDelimiters.find(delimiter => delimiter.limit_flow)
                this.form.delimiter = delimiter ? delimiter.id : null
            },
            /**
             * Configura dinâmicamente os labels dos campos de acordo com as configurações
             * selecionadas no formulário
             */
            setFieldLabels() {
                switch (this.form.data.type) {
                    case 'captation':
                    case 'present_value':
                    case 'entry':
                        this.$set(this.form.fields.tolerance, 'label', 'Tolerância Mín. (Opcional)')
                        break

                    default:
                        this.$set(this.form.fields.tolerance, 'label', 'Tolerância Máx. (Opcional)')
                        break;
                }
            },
            /**
             * Avalia um array com tipos de regras de acordo com o tipo selecionado
             */
            evaluateRules(rules) {
                return rules.includes(this.form.data.type)
            },
            /**
             * Configura dinâmicamente a propriedade disabled dos campos de acordo com as configurações
             * selecionadas no formulário
             */
            setDisabledFields() {
                this.$set(this.form.fields.days, 'disabled', this.evaluateRules(['present_value', 'balloon', 'entry']))
                this.$set(this.form.fields.tolerance, 'disabled', [0, 1].includes(parseInt(this.form.data.tolerance_status)))
            },
            /**
             * Configura dinâmicamente os campos como required de acordo com as configurações
             * selecionadas no formulário
             */
            setRequiredFields() {
                this.$set(this.form.fields.days, 'required', this.evaluateRules(['captation', 'bank_financing']))
                this.$set(this.form.fields.tolerance, 'required', parseInt(this.form.data.tolerance_status) === 2)
            },
            /**
             * Configura as propriedades do formulário
             */
            configFormFields() {
                this.setFieldLabels()
                this.setDisabledFields()
                this.setRequiredFields()
            },
            /**
             * Handler para tratar o evento de quando seleciona-se um status para a tolerância
             */
            toleranceStatusChangeHandler() {
                switch (parseInt(this.form.data.tolerance_status)) {
                    case 0:
                        this.$set(this.form.data, 'tolerance', '')
                        break

                    default:
                        this.$set(this.form.data, 'tolerance', 0)
                        break
                }

                this.configFormFields()
            },
            /**
             * Handler para tratar o evento de quando seleciona-se um tipo de regra
             */
            ruleTypeChangeHandler(value) {
                /** Caso o tipo da regra mude, reseta-se o formulário */
                this.clearForm()

                /**
                 * Encontra o objeto que representa o tipo de regra para setar a propriedade
                 * rule do formulário
                 */
                let rule = this.ruleTypeOptions.find(rule => rule.value === value)
                if (rule) {
                    this.$set(this.form.data, 'rule', rule.label)
                    this.$set(this.form.data, 'type', value)
                } else {
                    this.$set(this.form.data, 'rule', '')
                    this.$set(this.form.data, 'type', null)
                }

                this.configFormFields()
            },
            /**
             * Valida a propriedade required dos campos do formulário
             */
            validateRequired(field) {
                const required = this.form.fields[field].required
                const validation = this.form.data[field] || parseInt(this.form.data[field]) === 0

                return (required && validation) || !required
            },
            /**
             * Valida os campos do formulário de acordo com diferentes conjuntos de regras
             */
            validateForm() {
                let valid = true
                let message = '<ul>'

                if (!this.validateRequired('type')) {
                    valid = false
                    message += '<li>É necessário selecionar a regra.</li>'
                }

                if (!this.validateRequired('days')) {
                    valid = false
                    message += '<li>É necessário informar até quantos dias.</li>'
                }

                if (!this.validateRequired('amount')) {
                    valid = false
                    message += '<li>É necessário informar o total a ser recebido.</li>'
                }

                if (!this.validateRequired('tolerance_status')) {
                    valid = false
                    message += '<li>É necessário informar se a tolerância é necessária.</li>'
                }

                if (!this.validateRequired('tolerance')) {
                    valid = false
                    message += '<li>É necessário informar a tolerância.</li>'
                }

                if (String(this.form.data.sales_table_id).includes('random')
                    || !this.form.data.sales_table_id) {
                    valid = false
                    message += '<li>É necessário salvar a tabela de vendas antes de criar as regras do simulador.</li>'
                }

                message += '</ul>'

                return { valid, message }
            },
            /**
             * Valida os dados do formulário, submita os dados e mostra as mensagens de erro
             * caso seja necessário
             */
            submit() {
                const validation = this.validateForm()

                if (validation.valid) {
                    this.$set(this.form, 'message', '')
                    this.submitForm()
                } else {
                    this.$set(this.form, 'message', validation.message)
                }
            },
            /**
             * Submita os dados do formulário
             */
            submitForm() {
                this.loadingTableUpdate = true
                this.loadingAddRule = true

                if (this.form.data.id) {
                    simulatorRule.update('', this.form.data.id, { ...this.form.data })
                        .then(response => {
                            this.$toastr.s(response.data.msg)
                            this.$set(this.rules, this.form.editingIndex, { ...response.data.data })
                            this.clearForm()
                            this.loadingTableUpdate = false
                            this.loadingAddRule = false
                        })
                        .catch(error => {
                            if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                            console.log('error', error)
                            this.loadingTableUpdate = false
                            this.loadingAddRule = false
                        })
                } else {
                    simulatorRule.create('', { ...this.form.data })
                        .then(response => {
                            this.$toastr.s(response.data.msg)
                            this.$set(this.rules, this.rules.length, { ...response.data.data })
                            this.clearForm()
                            this.loadingTableUpdate = false
                            this.loadingAddRule = false
                        })
                        .catch(error => {
                            if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                            console.log('error', error)
                            this.loadingTableUpdate = false
                            this.loadingAddRule = false
                        })
                }
            },
            /**
             * Atualiza na tabela de vendas a propriedade duedates e nos fluxos
             * qual fluxo é o limitante
             */
            async submitSalesTable() {
                this.loadingSaveRule = true

                if (this.form.salesTable.id && !String(this.form.salesTable.id).includes('random')) {
                    let data = { ...this.form.salesTable }
                    /**
                     * Processa os fluxos de modo a definir o fluxo limitante antes de atualizar
                     * a tabela de vendas
                     */
                    for (let flow of data.sales_table_flow) {

                        if (flow.id === parseInt(this.form.delimiter)) {
                            flow.limit_flow = 1
                        } else {
                            flow.limit_flow = 0
                        }

                        await salesTable.updateFlow(flow.id, flow)
                            .catch(error => {
                                if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                                console.log('error', error)
                                this.loadingSaveRule = false
                            })
                    }

                    salesTable.update('', this.form.salesTable.id, { ...data })
                        .then(response => {
                            this.$store.dispatch('salesTable/setSalesTableConfig', response.data.data)
                            this.$toastr.s(response.data.msg)
                            this.loadingSaveRule = false
                        })
                        .catch(error => {
                            if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                            console.log('error', error)
                            this.loadingSaveRule = false
                        })
                } else {
                    this.$toastr.e('É necessário salvar a tabela de vendas antes de definir as regras do simulador.')
                    this.loadingSaveRule = false
                }
            },
            /**
             * Limpa os dados do formulário
             */
            clearForm() {
                this.$set(this.form, 'data', { ...defaultFormData(this.salesTableConfig) })
                this.$set(this.form, 'editing', false)
                this.$set(this.form, 'editingIndex', null)
            },
            /**
             * Altera o formulário para modo de edição e insere os dados a serem editados
             */
            editHandler(value) {
                this.loadingEditing = true

                this.$set(this.form, 'data', { ...value.data })
                this.$set(this.form, 'editing', true)
                this.$set(this.form, 'editingIndex', value.index)
                this.configFormFields()

                setTimeout(() => {
                    this.loadingEditing = false
                }, 809);
            },
            /**
             * Remove uma regra do simulador da tabela de regras
             */
            removeHandler(value) {
                this.loadingTableUpdate = true

                simulatorRule.delete('', value.id )
                    .then(response => {
                        this.$toastr.s(response.data.msg)
                        this.$delete(this.rules, value.index)
                        this.loadingTableUpdate = false
                    })
                    .catch(error => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                        console.log('error', error)
                        this.loadingTableUpdate = false
                    })
            }
        }
	}
</script>

<style lang="stylus" scoped>
@import './styles.styl';
</style>